"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/scp-heal-icon-text.svg.js",
    _path,
    _path2,
    _path3,
    _g,
    _defs;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 81,
    height: 32,
    viewBox: "0 0 81 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M40 11.283v-5.17h1.184v.738c.21-.503.717-.842 1.354-.842.686 0 1.154.298 1.403.903.288-.605.835-.903 1.641-.903 1.105 0 1.742.79 1.742 2.073v3.2h-1.195V8.256c0-.707-.329-1.148-.896-1.148-.587 0-.995.492-.995 1.2v2.975h-1.183V8.256c0-.707-.328-1.148-.895-1.148-.558 0-.976.502-.976 1.2v2.975H40zm9.692.07l-2.058-5.242h1.222l1.463 3.775 1.502-3.774h1.225l-2.946 7.16h-1.214l.806-1.918zm20.6-6.551c-.524-.493-1.266-.754-2.15-.754h-1.676v7.273h1.186V9.65h.49c.884 0 1.627-.259 2.148-.748.528-.495.807-1.203.807-2.043 0-.847-.279-1.558-.806-2.056zm-2.64.4h.452c1.186 0 1.788.557 1.788 1.656 0 1.086-.602 1.637-1.788 1.637h-.452V5.202zm-11.27 1.906l-.524-.255c-.783-.38-.98-.536-.98-.992 0-.43.315-.72.783-.72.485 0 .797.178 1.044.597l.15.254.954-.63-.147-.243C57.211 4.366 56.553 4 55.652 4c-1.129 0-1.948.79-1.948 1.88 0 1.064.633 1.584 1.656 2.079l.525.256c.818.39 1.054.654 1.054 1.178 0 .536-.42.856-1.126.856-.634 0-1.147-.318-1.444-.895l-.132-.256-1.023.555.133.258c.497.966 1.376 1.498 2.476 1.498.682 0 1.258-.186 1.664-.54.416-.363.636-.88.636-1.497 0-1.17-.666-1.736-1.741-2.264zm8.313 1.922l-.164.227c-.473.65-1.155.992-1.972.992-1.38 0-2.383-1.07-2.383-2.544 0-1.45 1.004-2.543 2.334-2.543.777 0 1.4.304 1.85.907l.17.223.932-.692-.176-.238c-.658-.89-1.615-1.36-2.765-1.36-2.028 0-3.557 1.591-3.557 3.703-.004 1.021.356 1.96 1.015 2.643a3.527 3.527 0 002.56 1.064c1.233 0 2.218-.488 2.928-1.45l.177-.24-.95-.692z",
    fill: "#878787",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M45.917 17.273h2.209v9.81h-2.209V22.92h-3.709v4.162H40v-9.81h2.208v3.751h3.71v-3.751zM51.811 27.083v-9.81h6.625v1.854H54.02v1.925h3.92v1.812h-3.92v2.364h4.742v1.855h-6.95zM68.38 27.083c-.104-.34-.222-.69-.354-1.048l-.368-1.076h-3.822c-.123.359-.25.718-.382 1.076-.123.359-.236.708-.34 1.048H60.82c.368-1.057.717-2.034 1.047-2.93.33-.897.651-1.742.963-2.534.32-.793.632-1.543.934-2.251a53.84 53.84 0 01.963-2.095h2.109c.32.68.637 1.378.948 2.095.312.708.623 1.458.935 2.25.32.793.646 1.638.976 2.535.33.896.68 1.873 1.048 2.93H68.38zm-2.647-7.588c-.047.142-.118.335-.213.58l-.325.85-.41 1.062c-.142.387-.288.792-.44 1.217h2.79c-.152-.425-.298-.83-.44-1.217-.141-.387-.278-.741-.41-1.062l-.326-.85c-.094-.245-.17-.438-.226-.58zM79.984 25.186v1.897h-6.555v-9.81h2.209v7.913h4.346z",
    fill: "#2A2A2A",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M25.6 0H6.4A6.4 6.4 0 000 6.4v19.2A6.4 6.4 0 006.4 32h19.2a6.4 6.4 0 006.4-6.4V6.4A6.4 6.4 0 0025.6 0z",
    fill: "url(#prefix__paint0_linear_5459_35297)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  })), _g || (_g = React.createElement("g", {
    clipPath: "url(#prefix__clip0_5459_35297)",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25
    },
    __self: this
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.131 6.8a4.215 4.215 0 11.007 8.43 4.215 4.215 0 01-.007-8.43z",
    fill: "#1C3D6B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26
    },
    __self: this
  }), React.createElement("path", {
    d: "M4.46 12.915S2.878 23.548 15.87 25.308c0 0-.628-12.287-11.409-12.393z",
    fill: "#0D1F36",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32
    },
    __self: this
  }), React.createElement("path", {
    d: "M27.54 12.915s1.593 10.633-11.409 12.393c0 0 .635-12.287 11.409-12.393z",
    fill: "#B5BD00",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 36
    },
    __self: this
  }))), _defs || (_defs = React.createElement("defs", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41
    },
    __self: this
  }, React.createElement("linearGradient", {
    id: "prefix__paint0_linear_5459_35297",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 32,
    gradientUnits: "userSpaceOnUse",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42
    },
    __self: this
  }, React.createElement("stop", {
    stopColor: "#F7F7F7",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50
    },
    __self: this
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51
    },
    __self: this
  })), React.createElement("clipPath", {
    id: "prefix__clip0_5459_35297",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53
    },
    __self: this
  }, React.createElement("path", {
    fill: "#fff",
    transform: "translate(4.4 6.8)",
    d: "M0 0h23.2v18.508H0z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54
    },
    __self: this
  })))));
}

var _default = ReactComponent;
exports["default"] = _default;